<template>
  <div>
    <!-- Avatar Row -->
    <ValidationObserver v-slot="{ handleSubmit }" ref="form">
      <form @submit.prevent="handleSubmit">
        <div class="flex -mx-2 mb-5">
          <div class="flex-1 px-2">
            <vx-card :title="$t('sections.accounting.dataSection.contractInformation')" collapse-action>
              <div class="vx-row mb-5 flex">
                <div class="vx-col w-1/4">
                  <validation-provider :name="$t('sections.accounting.dataForm.contractDate')" rules="required"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.contractDate') }}</label>
                    <flat-pickr :config="config" class="w-full" v-model="form.contractDate"
                                :disabled="contract.contractStatus !== 'Draft'"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col w-5/12">
                  <validation-provider :name="$t('sections.accounting.dataForm.borrower')" rules="required"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.borrower') }} <small class="ml-2"
                                                                                                            v-if="totalMatched > maxOptions">
                      #แสดงผลเพียง {{ maxOptions }} รายการจาก {{ totalMatched }} รายการที่พบ
                    </small></label>

                    <v-select
                      v-model="form.borrower"
                      :filterable="false"
                      :options="filteredBorrowers"
                      :clearable="true"
                      @search="onSearchBorrower"
                      label="label"
                    >
                    </v-select>

                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col flex-1">
                  <validation-provider :name="$t('sections.accounting.dataForm.contractNo')" rules="required|length:15"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t("sections.accounting.dataForm.contractNo") }}</label>
                    <vs-input type="text" class="w-full" v-model="form.contractNo" disabled="true"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col flex-1">
                  <validation-provider :name="$t('sections.accounting.dataForm.contractIndex')"
                                       rules="required|contractIndexFormat" v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.contractIndex') }}</label>
                    <vs-input type="text" class="w-full" v-model="form.contractIndex"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>

              <div class="vx-row mb-5 flex">
                <div class="vx-col w-1/4">
                  <validation-provider :name="$t('sections.accounting.dataForm.project')" rules="required"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.project') }}</label>
                    <v-select v-model="form.project" :clearable="false" :options="projectOptions"
                              :name="$t('sections.accounting.dataForm.project')" :reduce="res => res.value"
                              :disabled="true"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col w-5/12">
                  <validation-provider :name="$t('sections.accounting.dataForm.campus')" rules="required"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.campus') }}</label>
                    <v-select v-model="form.campus" :clearable="false" :options="filteredCampusOptions"
                              :name="$t('sections.accounting.dataForm.project')" :reduce="res => res.value"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col w-1/6">
                  <validation-provider :name="$t('sections.accounting.dataForm.periods.begin')" rules="required"
                                       v-slot="{ errors }">
                    <div class="vx-col flex-1">
                      <validation-provider :name="$t('sections.accounting.dataForm.periods.begin')"
                                           rules="required|periodTermYear" v-slot="{ errors }">
                        <label class="vs-input--label">ปีการศึกษาที่เริ่มกู้*</label>
                        <vs-input type="text" v-model="form.periodStart" class="w-full"/>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                  </validation-provider>
                </div>
                <div class="vx-col w-1/6">
                  <validation-provider :name="$t('sections.accounting.dataForm.periods.end')" rules="required"
                                       v-slot="{ errors }">
                    <div class="vx-col flex-1">
                      <validation-provider :name="$t('sections.accounting.dataForm.periods.end')"
                                           rules="required|periodTermYear" v-slot="{ errors }">
                        <label class="vs-input--label">ปีการศึกาษาสุดท้าย*</label>
                        <vs-input type="text" v-model="form.periodEnd" class="w-full"/>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                  </validation-provider>
                </div>
              </div>

              <div class="vx-row mb-5">
                <div class="vx-col w-2/3">
                  <validation-provider :name="$t('sections.accounting.dataForm.curriculum')" rules="required"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.curriculum') }}</label>
                    <v-select v-model="form.curriculum" :clearable="false" :options="facultyCurriculumOptions"
                              :name="$t('sections.accounting.dataForm.curriculum')" :reduce="res => res.value"
                              :disabled="true"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col w-1/6">
                  <validation-provider :name="$t('sections.accounting.dataForm.forecastDate')" v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.forecastDate') }}</label>
                    <flat-pickr :config="config" class="w-full" v-model="form.forecastDate"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col w-1/6">
                  <validation-provider :name="$t('sections.accounting.dataForm.graduationDate')" v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.graduationDate') }}</label>
                    <flat-pickr :config="config" class="w-full" v-model="form.graduationDate"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>

              <div class="vx-row mb-5">
                <div class="vx-col w-1/4">
                  <validation-provider :name="$t('sections.accounting.dataForm.contractAmount')" rules="required"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.contractAmount') }}</label>
                    <vs-input type="number" class="w-full" v-model="form.contractAmount"
                              :disabled="!reCalculate || contract.contractStatus !== 'Draft'"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col w-5/12">
                  <validation-provider :name="$t('sections.accounting.dataForm.contractAmountText')" rules="required"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.contractAmountText') }}</label>
                    <vs-input type="text" class="w-full" v-model="form.contractAmountText" disabled="true"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col flex-1">
                  <validation-provider :name="$t('sections.accounting.dataForm.loan.period')" rules="required"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.loan.period') }}</label>
                    <vs-input type="number" class="w-full" v-model="form.loan.period" :disabled="!reCalculate"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col flex-1">
                  <validation-provider :name="$t('sections.accounting.dataForm.loan.paymentDue')" rules="required"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.loan.paymentDue') }}</label>
                    <flat-pickr :config="configPaymentDue" class="w-full" v-model="form.loan.paymentDue"
                                :disabled="!reCalculate"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>

              <div class="vx-row mb-5 flex">
                <div class="vx-col w-2/3">
                  <validation-provider :name="$t('sections.accounting.dataForm.loan.loanType')" rules="required"
                                       v-slot="{ errors }">
                    <label class="vs-input--label">{{ $t('sections.accounting.dataForm.loan.loanType') }}</label>
                    <v-select v-model="form.loan.loanType" :clearable="false" :options="loanTypesOptions"
                              :name="$t('sections.accounting.dataForm.loan.loanType')" :reduce="res => res.value"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>

              <div class="vx-row flex">
                <div class="vx-col flex-1">
                  <validation-provider :name="$t('sections.accounting.dataForm.loan.paymentDescription')" rules=""
                                       v-slot="{ errors }">
                    <label
                      class="vs-input--label">{{ $t('sections.accounting.dataForm.loan.paymentDescription') }}</label>
                    <vs-textarea v-model="form.loan.paymentDescription" rows="6" class="mt-2"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col w-1/3">
                  <div class="vx-row">
                    <div class="vx-col flex-1">
                      <validation-provider :name="$t('sections.accounting.dataForm.loan.interestRate')" rules="required"
                                           v-slot="{ errors }">
                        <label
                          class="vs-input--label">{{ $t('sections.accounting.dataForm.loan.interestRate') }}</label>
                        <vs-input type="number" class="w-full" v-model="form.loan.interestRate"
                                  :disabled="!reCalculate"/>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                    <div class="vx-col flex-1">
                      <validation-provider :name="$t('sections.accounting.dataForm.loan.interestType')" rules="required"
                                           v-slot="{ errors }">
                        <label
                          class="vs-input--label">{{ $t('sections.accounting.dataForm.loan.interestType') }}</label>
                        <vs-select v-model="form.loan.interestType" class="w-full select-large"
                                   :disabled="!reCalculate">
                          <vs-select-item :key="index" :value="item.value" :text="item.label"
                                          v-for="(item,index) in interestTypesOptions" class="w-full"/>
                        </vs-select>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col flex-1">
                      <validation-provider :name="$t('sections.accounting.dataForm.loan.penaltyRate')" rules="required"
                                           v-slot="{ errors }">
                        <label class="vs-input--label">{{ $t('sections.accounting.dataForm.loan.penaltyRate') }}</label>
                        <vs-input type="number" class="w-full" v-model="form.loan.penaltyRate"
                                  :disabled="!reCalculate"/>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                    <div class="vx-col flex-1">
                      <validation-provider :name="$t('sections.accounting.dataForm.loan.penaltyType')" rules="required"
                                           v-slot="{ errors }">
                        <label class="vs-input--label">{{ $t('sections.accounting.dataForm.loan.penaltyType') }}</label>
                        <vs-select v-model="form.loan.penaltyType" class="w-full select-large" :disabled="!reCalculate">
                          <vs-select-item :key="index" :value="item.value" :text="item.label"
                                          v-for="(item,index) in interestTypesOptions" class="w-full"/>
                        </vs-select>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col flex-1">
                      <validation-provider name="ค่าธรรมเนียมการทวงถาม" rules="required" v-slot="{ errors }">
                        <label class="vs-input--label">ค่าธรรมเนียมการทวงถาม</label>
                        <vs-input type="text" class="w-full" v-model="form.loan.debtCollectionFeeAmount"
                                  disabled="disabled"/>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                    <div class="vx-col flex-1">
                      <validation-provider name="การคิดค่าธรรมเนียมการทวงถาม" rules="required" v-slot="{ errors }">
                        <label class="vs-input--label">การคิดค่าธรรมเนียมการทวงถาม</label>
                        <vs-select v-model="form.loan.debtCollectionFeeType" class="w-full" :disabled="!reCalculate">
                          <vs-select-item :key="index" :value="item.value" :text="item.label"
                                          v-for="(item,index) in debtCollectionFeeTypesOptions" class="w-full"/>
                        </vs-select>
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </validation-provider>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="flex items-center mb-4" v-if="contract.contractStatus === 'Draft'">
                  <vs-switch v-model="reCalculate"/>
                  <span class="ml-4">{{ $t('general.reCalculate') }}</span>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
        <div class="flex -mx-2 mb-5">
          <div class="flex-1 px-2">
            <vx-card :title="$t('sections.accounting.dataSection.suretyInformation')" collapse-action>
              <div class="vx-row">
                <div class="vx-col w-full vx-coll-fixed-height">
                  <vs-table :data="suretyDetails">
                    <template slot="thead">
                      <vs-th class="w-1/6">ลำดับ</vs-th>
                      <vs-th>ชื่อนามสกุล</vs-th>
                      <vs-th>เกี๋ยวข้องเป็น</vs-th>
                      <vs-th class="w-1/6"></vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr :key="index" v-for="(row, index) in data">
                        <vs-td :data="(index+1)">
                          {{ (index + 1) }}
                        </vs-td>
                        <vs-td>
                          {{ suretyName(row.surety.id) }}
                        </vs-td>
                        <vs-td>
                          <vs-select v-model="row.relationship" class="w-full ">
                            <vs-select-item :key="index" :value="item.value" :text="item.label"
                                            v-for="(item,index) in relationshipOptions" class="w-full"/>
                          </vs-select>
                        </vs-td>
                        <vs-td>
                          <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-delete"
                                     @click="delSureties(index)"></vs-button>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                  <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus-square"
                             @click="addSureties()"></vs-button>
                </div>
              </div>
            </vx-card>
          </div>
          <div class="flex-1 px-2">
            <vx-card :title="$t('sections.accounting.dataSection.paymentRoundInformation')" collapse-action>
              <div class="vx-row">
                <div class="vx-col w-full vx-coll-fixed-height">
                  <vs-table :data="paymentRounds">

                    <template slot="thead">
                      <vs-th class="w-1/12">{{ $t('sections.accounting.dataForm.tablePaymentRound.no') }}</vs-th>
                      <vs-th class="w-1/6">{{ $t('sections.accounting.dataForm.tablePaymentRound.date') }}</vs-th>
                      <vs-th class="w-1/4">{{ $t('sections.accounting.dataForm.tablePaymentRound.type') }}</vs-th>
                      <vs-th :class="[ contract.restructuring ? 'w-1/6' : 'w-1/3']">
                        {{ $t('sections.accounting.dataForm.tablePaymentRound.amount') }}
                      </vs-th>
                      <vs-th class="w-1/6" v-if="contract.restructuring">
                        {{ $t('sections.accounting.dataForm.tablePaymentRound.restructuringAmount') }}
                      </vs-th>
                      <vs-th class="w-1/12"></vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr :key="index" v-for="(tr, index) in data">
                        <vs-td :data="tr.paymentRoundSeq">
                          {{ tr.paymentRoundSeq }}
                        </vs-td>
                        <vs-td :data="tr.paymentRoundDate">
                          {{ tr.paymentRoundDate }}
                        </vs-td>
                        <vs-td :data="tr.paymentRoundType">
                          <vs-select v-model="tr.paymentRoundType" class="w-full select-large" :disabled="!reCalculate">
                            <vs-select-item :key="index" :value="item.value" :text="item.label"
                                            v-for="(item, index) in paymentRoundTypesOptions" class="w-full"/>
                          </vs-select>
                        </vs-td>
                        <vs-td :data="tr.paymentRoundAmount">
                          <vs-input v-if="['Principle', 'InterestFixed'].includes(tr.paymentRoundType)" type="number"
                                    class="w-full" v-model="tr.paymentRoundAmount" :disabled="!reCalculate"/>
                          <vs-input v-if="!['Principle', 'InterestFixed'].includes(tr.paymentRoundType)" type="number"
                                    class="w-full" :value="0" disabled="disabled"/>
                        </vs-td>
                        <vs-td :data="tr.paymentRoundAmountRestructuring" v-if="contract.restructuring">
                          <vs-input
                            v-if="['Principle', 'InterestFixed'].includes(tr.paymentRoundType) && contract.restructuring"
                            type="number" class="w-full" v-model="tr.paymentRoundAmountRestructuring"
                            :disabled="!reCalculate"/>
                          <vs-input
                            v-if="!['Principle', 'InterestFixed'].includes(tr.paymentRoundType) || !contract.restructuring"
                            type="number" class="w-full" :value="0" disabled="disabled"/>
                        </vs-td>
                        <vs-td>
                          <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-down" size="small"
                                     @click="copyPaymentRounds(index)" v-if="reCalculate"></vs-button>
                        </vs-td>
                      </vs-tr>
                    </template>

                  </vs-table>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
        <div class="flex -mx-2 mb-5" v-if="!contract.restructuring">
          <div class="w-1/2 px-2">
            <vx-card title="ข้อมูลเงินกู้" collapse-action>
              <div class="vx-row">
                <div class="vx-col w-full vx-coll-fixed-height">
                  <vs-table :data="loanDetails">
                    <template slot="thead">
                      <vs-th class="w-1/12">{{ $t('sections.accounting.dataForm.tableLoanDetail.no') }}</vs-th>
                      <vs-th class="w-1/3">{{ $t('sections.accounting.dataForm.tableLoanDetail.type') }}</vs-th>
                      <vs-th class="w-1/3">{{ $t('sections.accounting.dataForm.tableLoanDetail.date') }}</vs-th>
                      <vs-th class="w-1/2">{{ $t('sections.accounting.dataForm.tableLoanDetail.amount') }}</vs-th>
                      <vs-th class="w-1/12"></vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr :key="index" v-for="(tr, index) in data">
                        <vs-td :data="(index+1)">
                          {{ (index + 1) }}
                        </vs-td>
                        <vs-td :data="tr.loanDetailType">
                          <vs-select v-model="tr.loanDetailType" class="w-full select-large" :disabled="!reCalculate">
                            <vs-select-item :key="index" :value="item.value" :text="item.label"
                                            v-for="(item,index) in loanDetailTypesOptions" class="w-full"/>
                          </vs-select>
                        </vs-td>
                        <vs-td :data="tr.loanDate">
                          <flat-pickr :config="config" class="w-full" v-model="tr.loanDate" :disabled="!reCalculate"/>
                        </vs-td>
                        <vs-td :data="tr.amount">
                          <vs-input type="number" class="w-full" v-model="tr.amount" :disabled="!reCalculate"/>
                        </vs-td>
                        <vs-td>
                          <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-delete"
                                     @click="delLoanDetails(index)" :disabled="!reCalculate"></vs-button>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                  <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus-square"
                             @click="addLoanDetails()" :disabled="!reCalculate"></vs-button>
                </div>
              </div>
            </vx-card>
          </div>
          <div class="w-1/2 px-2">
            <vx-card :title="$t('sections.accounting.dataSection.loanPlanInformation')" collapse-action>
              <div class="vx-row">
                <div class="vx-col w-full vx-coll-fixed-height">
                  <vs-table :data="loanDetailPlans">
                    <template slot="thead">
                      <vs-th class="w-1/12">{{ $t('sections.accounting.dataForm.tableLoanDetail.no') }}</vs-th>
                      <vs-th class="w-1/3">{{ $t('sections.accounting.dataForm.tableLoanDetail.type') }}</vs-th>
                      <vs-th class="w-1/3">{{ $t('sections.accounting.dataForm.tableLoanDetail.date') }}</vs-th>
                      <vs-th class="w-1/2">{{ $t('sections.accounting.dataForm.tableLoanDetail.amount') }}</vs-th>
                      <vs-th class="w-1/12"></vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr :key="index" v-for="(tr, index) in data">
                        <vs-td :data="(index+1)">
                          {{ (index + 1) }}
                        </vs-td>
                        <vs-td :data="tr.loanDetailType">
                          <vs-select v-model="tr.loanDetailType" class="w-full select-large" :disabled="!reCalculate">
                            <vs-select-item :key="index" :value="item.value" :text="item.label"
                                            v-for="(item,index) in loanDetailTypesOptions" class="w-full"/>
                          </vs-select>
                        </vs-td>
                        <vs-td :data="tr.loanDate">
                          <flat-pickr :config="config" class="w-full" v-model="tr.loanDate" :disabled="!reCalculate"/>
                        </vs-td>
                        <vs-td :data="tr.amount">
                          <vs-input type="number" class="w-full" v-model="tr.amount" :disabled="!reCalculate"/>
                        </vs-td>
                        <vs-td>
                          <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-delete"
                                     @click="delLoanDetailPlans(index)" :disabled="!reCalculate"></vs-button>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                  <vs-button color="success" type="flat" icon-pack="feather" icon="icon-plus-square"
                             @click="addLoanDetailPlans()" :disabled="!reCalculate"></vs-button>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
        <div class="flex -mx-2 mb-5" v-if="contract.restructuring">
          <div class="w-1/2 px-2">
            <vx-card :title="$t('sections.accounting.dataSection.restructuringInformation')" collapse-action>
              <div class="vx-row mb-5 flex">
                <div class="vx-col w-5/6">
                  <validation-provider :name="$t('sections.accounting.dataForm.restructuringDetail.restructuringDate')"
                                       rules="required" v-slot="{ errors }">
                    <label class="vs-input--label">{{
                        $t('sections.accounting.dataForm.restructuringDetail.restructuringDate')
                      }}
                      <small class="text-grey">(ดึงข้อมูลวันที่ -1 ณ สิ้นวัน กรุณาตรวจสอบการชำระเงิน, การโอนเงิน
                        หลังวันที่ดังกล่าว)</small>
                    </label>
                    <flat-pickr :config="configRestructuringDate" class="w-full"
                                v-model="restructuringDetail.restructuringDate" :disabled="!reCalculate"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col vx-row w-1/6">
                  <div class="flex items-center mt-5">
                    <vs-button class="btn btn-primary" size="small" color="success"
                               @click="fncGetRestructuringDetailByDate()" :disabled="!reCalculate">{{ "ดึงข้อมูล" }}
                    </vs-button>
                  </div>
                </div>
              </div>
              <div class="vx-row mb-5 flex">
                <div class="vx-col flex-1">
                  <validation-provider name="[วันที่  นโยบายปรับโครงสร้างหนี้]: มาตรการย่อย" rules="" v-slot="{ errors }">
                    <label class="vs-input--label">[วันที่  นโยบายปรับโครงสร้างหนี้]: มาตรการย่อย</label>
                    <v-select v-model="form.subMeasure" :clearable="true" :options="subMeasureOptions"
                              name="นโยบายปรับโครงสร้างหนี้" :reduce="res => res.value" :disabled="!reCalculate"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>
              <div class="vx-row mb-5 flex">
                <div class="vx-col flex-1">
                  <validation-provider name="ประเภทการปรับโครงสร้างหนี้" rules="required" v-slot="{ errors }">
                    <label class="vs-input--label">ประเภทการปรับโครงสร้างหนี้</label>
                    <v-select v-model="form.restructuringType" :clearable="false" :options="restructuringTypesOptions"
                              name="ประเภทการปรับโครงสร้างหนี้" :reduce="res => res.value" :disabled="!reCalculate"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>
              <div class="vx-row mb-5 flex">
                <div class="vx-col w-1/2">
                  <validation-provider :name="$t('sections.accounting.dataForm.restructuringDetail.principleRemain')"
                                       rules="required" v-slot="{ errors }">
                    <label
                      class="vs-input--label">{{
                        $t('sections.accounting.dataForm.restructuringDetail.principleRemain')
                      }}</label>
                    <vs-input type="number" class="w-full" v-model="restructuringDetail.principleRemain"
                              :disabled="!reCalculate"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col w-1/2">
                  <validation-provider :name="$t('sections.accounting.dataForm.restructuringDetail.accruedFeeRemain')"
                                       rules="required" v-slot="{ errors }">
                    <label
                      class="vs-input--label">{{
                        $t('sections.accounting.dataForm.restructuringDetail.accruedFeeRemain')
                      }}</label>
                    <vs-input type="number" class="w-full" v-model="restructuringDetail.restructuringFeeRemain"
                              :disabled="!reCalculate"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>
              <div class="vx-row mb-5 flex">
                <div class="vx-col w-1/2">
                  <validation-provider
                    :name="$t('sections.accounting.dataForm.restructuringDetail.accruedPenaltyRemain')" rules="required"
                    v-slot="{ errors }">
                    <label
                      class="vs-input--label">{{
                        $t('sections.accounting.dataForm.restructuringDetail.accruedPenaltyRemain')
                      }}</label>
                    <vs-input type="number" class="w-full" v-model="restructuringDetail.restructuringPenaltyRemain"
                              :disabled="!reCalculate"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
                <div class="vx-col w-1/2">
                  <validation-provider
                    :name="$t('sections.accounting.dataForm.restructuringDetail.accruedInterestRemain')"
                    rules="required" v-slot="{ errors }">
                    <label
                      class="vs-input--label">{{
                        $t('sections.accounting.dataForm.restructuringDetail.accruedInterestRemain')
                      }}</label>
                    <vs-input type="number" class="w-full" v-model="restructuringDetail.restructuringInterestRemain"
                              :disabled="!reCalculate"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>
              <div class="vx-row mb-5 flex">
                <div class="vx-col flex-1">
                  <validation-provider :name="$t('sections.accounting.dataForm.restructuringDetail.remark')" rules=""
                                       v-slot="{ errors }">
                    <label
                      class="vs-input--label">{{
                        $t('sections.accounting.dataForm.restructuringDetail.remark')
                      }}</label>
                    <vs-textarea v-model="restructuringDetail.remark" rows="6fsu" class="mt-2"
                                 :disabled="!reCalculate"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>
            </vx-card>
          </div>
          <div class="w-1/2 px-2">
            <vx-card :title="$t('sections.accounting.dataSection.paymentInformation')" collapse-action>
              <payment-information :manage="false" :payment-extra="false"/>
            </vx-card>
          </div>
        </div>
        <!-- Save & Reset Button -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex flex-wrap items-center justify-end">
              <vs-button class="ml-auto mt-2" @click="submit" v-if="contract.contractStatus === 'Draft'">
                {{ $t("sections.accounting.dataForm.action.btnSave") }}
              </vs-button>
              <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset"
                         v-if="contract.contractStatus === 'Draft'">
                {{ $t("sections.accounting.dataForm.action.btnReset") }}
              </vs-button>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>

    <vs-prompt
      @accept="acceptModal"
      @cancel="cancelModal"
      @close="closeModal"
      :active.sync="activeModal.active">
      <div class="vx-col w-full">
        <label class="vs-input--label">ผู้ค้ำประกัน <small class="ml-2"
                                                           v-if="totalSuretyMatched > maxOptions">
          #แสดงผลเพียง {{ maxOptions }} รายการจาก {{ totalSuretyMatched }} รายการที่พบ
        </small></label>
        <div class="flex">
          <div class="mr-1 flex-1">
            <v-select
              v-model="surety"
              :filterable="false"
              :options="filteredSureties"
              :clearable="true"
              @search="onSearchSurety"
              label="label"
            >
            </v-select>
          </div>
          <div>
            <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-refresh-ccw"
                       @click="onPressedRefreshSuretyOptions()"></vs-button>
          </div>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import {Thai} from 'flatpickr/dist/l10n/th'
import 'flatpickr/dist/themes/dark.css';
import {ValidationProvider} from 'vee-validate'
import {createNamespacedHelpers, mapGetters} from "vuex";
import THBText from 'thai-baht-text'
import {getLastDay, isLastDay} from '@/utils'
import PaymentInformation
  from "@/views/pages/Accounting/Transaction/Manage/ContractHeaderDetail/PaymentInformation.vue";
import {
  IContractStatus,
  IDebtCollectionFeeType,
  IInterestType,
  ILoanDetailType,
  IPaymentRoundType,
} from "@/constants/interface";
import {interestRateDefault} from "@/constants/config";

const moment = require('moment');

const {mapActions: mapCustomerActions, mapState: mapCustomerFields} = createNamespacedHelpers("Customer");
const {mapActions: mapAccountingActions, mapState: mapAccountingFields} = createNamespacedHelpers("Accounting");
const {mapActions: mapMasterActions, mapState: mapMasterFields} = createNamespacedHelpers("Master");

export default {
  components: {
    PaymentInformation,
    vSelect,
    ValidationProvider,
    flatPickr
  },
  data() {
    return {
      form: {
        contractDate: "",
        contractNo: "",
        contractIndex: "",
        contractName: "",
        borrower: "",
        contractAmount: 0,
        contractAmountText: "",
        project: "",
        campus: "",
        curriculum: "",
        educationStatus: "",
        forecastDate: "",
        graduationDate: "",
        periodStart: "",
        periodTermStart: "",
        periodYearStart: 0,
        periodEnd: "",
        periodTermEnd: "",
        periodYearEnd: 0,
        subMeasure: "",
        restructuringType: "",
        loan: {
          loanType: "",
          interestType: '',
          interestRate: 0,
          penaltyType: '',
          penaltyRate: 0,
          interestTypeEir: '',
          interestRateEir: 0,
          debtCollectionFeeAmount: interestRateDefault.debtCollectionFeeAmount,
          debtCollectionFeeType: IDebtCollectionFeeType.fixed,
          period: 0,
          paymentDue: new Date(),
          paymentDescription: ""
        }
      },
      restructuringDetail: {
        restructuringDate: new Date(),
        restructuringFeeRemain: 0,
        restructuringPenaltyRemain: 0,
        restructuringInterestRemain: 0,
        principleRemain: 0,
        remark: "",
      },
      suretyDetails: [],
      loanDetails: [],
      loanDetailPlans: [],
      paymentRounds: [],
      activeModal: {
        active: false,
      },
      surety: "",
      reCalculate: false,
      config: {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y",
      },
      configPaymentDue: {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y",
        disable: [
          function (date) {
            return !(isLastDay(date));
          }
        ]
      },
      configRestructuringDate: {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y",
      },
      filteredBorrowers: [],
      filteredSureties: [],
      totalMatched: 0,
      totalSuretyMatched: 0,
      searchTimeout: null,
      searchSuretyTimeout: null,
      maxOptions: 10,
      debounceTime: 500,
    };
  },
  async created() {
    const vm = this
    vm.$vs.loading();
    const {
      facultyCurriculumOptions,
      projectOptions,
      campusOptions,
      borrowerContractOptions,
      relationshipOptions,
      suretyContractOptions,
      subMeasureOptions
    } = vm;
    const {
      getSearchCurriculums,
      getSearchProjects,
      getCampusOptions,
      getBorrowerContractOptions,
      getRelationshipOptions,
      getSuretyContractOptions,
      getSubMeasureOptions,
      getContractEdit
    } = vm;
    if (facultyCurriculumOptions.length === 0) await getSearchCurriculums();
    if (projectOptions.length === 0) await getSearchProjects();
    if (campusOptions.length === 0) await getCampusOptions();
    if (borrowerContractOptions.length === 0) await getBorrowerContractOptions();
    if (suretyContractOptions.length === 0) await getSuretyContractOptions();
    if (relationshipOptions.length === 0) await getRelationshipOptions();
    if (subMeasureOptions.length === 0) await getSubMeasureOptions();
    await getContractEdit({form: {id: vm.$route.params.id}});

    const selectedBorrower = vm.borrowerContractOptions.find(b => b.value === vm.contract.borrower.id);
    await this.onSearchBorrower(selectedBorrower.label);
    await this.onSearchSurety('');

    vm.pms("AccountingContract", "edit", "r");
    vm.reset();
    setTimeout(() => {
      vm.created = true
    }, 500);
  },
  computed: {
    ...mapMasterFields(["curriculums", "projects", "campuses", "subMeasures"]),
    ...mapAccountingFields([
      "status",
      "contract",
      "contractStatusTransactions"
    ]),
    ...mapCustomerFields(["borrowers", "sureties"]),
    ...mapGetters({
      facultyCurriculumOptions: "Master/facultyCurriculumOptions",
      projectOptions: "Master/projectOptions",
      campusOptions: "Master/campusOptions",
      borrowerContractOptions: "Customer/borrowerContractOptions",
      suretyContractOptions: "Customer/suretyContractOptions",

      statusesOptions: "Master/statusesOptions",
      loanTypesOptions: "Master/loanTypesOptions",
      subMeasureOptions: "Master/subMeasureOptions",
      restructuringTypesOptions: "Master/restructuringTypesOptions",
      educationStatusesOptions: "Master/educationStatusesOptions",
      paymentRoundTypesOptions: "Master/paymentRoundTypesOptions",
      loanDetailTypesOptions: "Master/loanDetailTypesOptions",
      interestTypesOptions: "Master/interestTypesOptions",
      debtCollectionFeeTypesOptions: "Master/debtCollectionFeeTypesOptions",

      relationshipOptions: "Master/relationshipOptions",
    }),
    filteredCampusOptions() {
      // Filter campuses based on selected project
      return this.campusOptions.filter(campus => campus.projectId === this.form.project);
    },
    restructuring() {
      return this.contract.restructuring || false;
    },
  },
  methods: {
    ...mapAccountingActions([
      "getContractEdit",
      "getRestructuringDetailByDate",
      "updateContract",
      "updateContractStatus",
    ]),
    ...mapMasterActions([
      "getSearchProjects",
      "getSearchCurriculums",
      "getCampusOptions",
      'getRelationshipOptions',
      "getSubMeasureOptions",
    ]),
    ...mapCustomerActions([
      "getBorrowerContractOptions",
      "getSuretyContractOptions",
      "getBorrowersCreatedByCurrentUser",
      "getSuretiesCreatedByCurrentUser"
    ]),
    onSearchBorrower(searchText) {
      clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(() => {
        const search = searchText.trim().toLowerCase();

        const matched = this.borrowerContractOptions.filter(b =>
          b.label.toLowerCase().includes(search)
        );

        this.totalMatched = matched.length;
        this.filteredBorrowers = matched.slice(0, this.maxOptions);
      }, this.debounceTime);
    },
    onSearchSurety(searchText) {
      clearTimeout(this.searchSuretyTimeout);

      this.searchSuretyTimeout = setTimeout(() => {
        const search = searchText.trim().toLowerCase();

        const matched = this.suretyContractOptions.filter(b =>
          b.label.toLowerCase().includes(search)
        );

        this.totalSuretyMatched = matched.length;
        this.filteredSureties = matched.slice(0, this.maxOptions);
      }, this.debounceTime);
    },
    async submit() {
      const vm = this;
      const {updateContract} = vm;
      vm.$refs["form"].validate().then(async success => {
        if (!success) {
          alert("กรุณากำหนดข้อมูลให้ครบถ้วน")
          return;
        } else if (vm.form.restructuring === false && vm.loanDetails.length === 0) {
          alert("กรุณากำหนดข้อมูลเงินกู้อย่างน้อย 1 รายการ")
          return;
        } else if (vm.form.loan.period <= 0 || vm.paymentRounds.length === 0) {
          alert("กรุณากำหนดรอบชำระอย่างน้อย 1 รายการ")
          return;
        } else if (vm.suretyDetails.filter(res => res.relationship === '').length >= 1) {
          alert("กรุณากำหนดความสัมพันธ์ของผู้ค้ำประกันให้ครบถ้วน")
          return;
        }
        await updateContract({
          id: vm.$route.params.id,
          reCalculate: vm.reCalculate,
          form: {
            contractDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.contractDate),
            contractIndex: vm.form.contractIndex,
            borrower: {id: vm.form.borrower ? vm.form.borrower.id : ''},
            suretyDetails: vm.suretyDetails.map((res, index) => {
              return {
                surety: {id: res.surety ? res.surety.id : ''},
                seq: (index + 1),
                relationship: {id: res.relationship || ''},
              }
            }),
            contractAmount: parseFloat(vm.form.contractAmount),
            contractAmountText: vm.form.contractAmountText,
            project: {id: vm.form.project || ''},
            campus: {id: vm.form.campus || ''},
            curriculum: {id: vm.form.curriculum || ''},
            educationStatus: vm.form.educationStatus,
            forecastDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.forecastDate),
            graduationDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.graduationDate),
            periodTermStart: vm.form.periodStart.split('/')[0].toString(),
            periodYearStart: parseInt(vm.form.periodStart.split('/')[1]),
            periodTermEnd: vm.form.periodEnd.split('/')[0].toString(),
            periodYearEnd: parseInt(vm.form.periodEnd.split('/')[1]),
            subMeasure:  { id: vm.form.subMeasure || ''},
            restructuringType: vm.form.restructuringType,
            restructuringDetail: {
              restructuringDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.restructuringDetail.restructuringDate),
              restructuringFeeRemain: parseFloat(vm.restructuringDetail.restructuringFeeRemain),
              restructuringPenaltyRemain: parseFloat(vm.restructuringDetail.restructuringPenaltyRemain),
              restructuringInterestRemain: parseFloat(vm.restructuringDetail.restructuringInterestRemain),
              principleRemain: parseFloat(vm.restructuringDetail.principleRemain),
              remark: vm.restructuringDetail.remark,
            },
            loan: {
              loanType: vm.form.loan.loanType,
              interestType: vm.form.loan.interestType,
              interestRate: parseFloat(vm.form.loan.interestRate),
              penaltyType: vm.form.loan.penaltyType,
              penaltyRate: parseFloat(vm.form.loan.penaltyRate),
              interestRateEir: parseFloat(vm.form.loan.interestRateEir),
              // debtCollectionFeeAmount: "50,100",
              debtCollectionFeeType: vm.form.loan.debtCollectionFeeType,
              period: parseInt(vm.form.loan.period),
              paymentDue: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.loan.paymentDue),
              paymentDescription: vm.form.loan.paymentDescription,
              loanDetails: !vm.contract.restructuring ? vm.loanDetails.map(res => {
                return {
                  id: res.id,
                  seq: parseInt(res.seq),
                  loanDetailType: res.loanDetailType,
                  loanDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(res.loanDate),
                  amount: parseFloat(res.amount),
                }
              }) : [],
              loanDetailPlans: vm.loanDetailPlans.map(res => {
                return {
                  seq: parseInt(res.seq),
                  loanDetailType: res.loanDetailType,
                  loanDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(res.loanDate),
                  amount: parseFloat(res.amount),
                }
              }),
              paymentRounds: vm.paymentRounds.map(res => {
                return {
                  paymentRoundSeq: parseInt(res.paymentRoundSeq),
                  paymentRoundType: res.paymentRoundType,
                  paymentRoundDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(res.paymentRoundDate),
                  paymentRoundAmount: parseFloat(res.paymentRoundAmount),
                  paymentRoundAmountRestructuring: parseFloat(res.paymentRoundAmountRestructuring)
                }
              })
            }
          },
          vm
        });
        // await vm.$router.push(`/accounting/contract/detail/${vm.$route.params.id}`);
        vm.reCalculate = false
      });
    },
    reset() {
      const vm = this;
      const selectedBorrower = vm.borrowerContractOptions.find(b => b.value === vm.contract.borrower.id);
      vm.form = {
        contractDate: vm.$options.filters.convYYYYMMDDToDDMMYYYY(vm.contract.contractDate),
        contractNo: vm.contract.contractNo,
        contractIndex: vm.contract.contractIndex || "",
        contractName: vm.contract.contractName,
        borrower: selectedBorrower,
        contractAmount: vm.contract.contractAmount,
        contractAmountText: vm.contract.contractAmountText,
        project: (vm.contract.project ? vm.contract.project.id : ''),
        campus: (vm.contract.campus ? vm.contract.campus.id : ''),
        curriculum: (vm.contract.curriculum ? vm.contract.curriculum.id : ''),
        educationStatus: vm.contract.educationStatus,
        forecastDate: vm.contract.forecastDate ? vm.$options.filters.convYYYYMMDDToDDMMYYYY(vm.contract.forecastDate) : '',
        graduationDate: vm.contract.graduationDate ? vm.$options.filters.convYYYYMMDDToDDMMYYYY(vm.contract.graduationDate) : '',
        periodStart: `${vm.contract.periodTermStart}/${vm.contract.periodYearStart}`,
        periodTermStart: vm.contract.periodTermStart,
        periodYearStart: vm.contract.periodYearStart,
        periodEnd: `${vm.contract.periodTermEnd}/${vm.contract.periodYearEnd}`,
        periodTermEnd: vm.contract.periodTermEnd,
        periodYearEnd: vm.contract.periodYearEnd,
        subMeasure:  (vm.contract.subMeasure ? vm.contract.subMeasure.id : ''),
        restructuringType: vm.contract.restructuringType,
        loan: {
          loanType: vm.contract.loan.loanType,
          interestType: vm.contract.loan.interestType,
          interestRate: vm.contract.loan.interestRate,
          penaltyType: vm.contract.loan.penaltyType,
          penaltyRate: vm.contract.loan.penaltyRate,
          interestTypeEir: IInterestType.principle,
          interestRateEir: vm.contract.loan.interestRateEir,
          debtCollectionFeeAmount: interestRateDefault.debtCollectionFeeAmount,
          debtCollectionFeeType: vm.contract.loan.debtCollectionFeeType,
          period: vm.contract.loan.period,
          paymentDue: vm.$options.filters.convYYYYMMDDToDDMMYYYY(vm.contract.loan.paymentDue),
          paymentDescription: vm.contract.loan.paymentDescription,
        }
      };
      setTimeout(function () {
        if (vm.contract.restructuring) {
          vm.restructuringDetail = {
            restructuringDate: vm.$options.filters.convYYYYMMDDToDDMMYYYY(vm.contract.restructuringDetail.restructuringDate),
            restructuringFeeRemain: vm.contract.restructuringDetail.restructuringFeeRemain,
            restructuringPenaltyRemain: vm.contract.restructuringDetail.restructuringPenaltyRemain,
            restructuringInterestRemain: vm.contract.restructuringDetail.restructuringInterestRemain,
            principleRemain: vm.contract.restructuringDetail.principleRemain,
            remark: vm.contract.restructuringDetail.remark,
          }
        }
        vm.suretyDetails = Object.assign([], vm.contract.suretyDetails).map(res => {
          return {
            ...res,
            relationship: res ? res.relationshipId : ''
          }
        });
        vm.loanDetails = Object.assign([], vm.contract.loan.loanDetails).map(res => {
          return {
            ...res,
            loanDate: vm.$options.filters.convYYYYMMDDToDDMMYYYY(res.loanDate),
          }
        });
        vm.loanDetailPlans = Object.assign([], vm.contract.loan.loanDetailPlans).map(res => {
          return {
            ...res,
            loanDate: vm.$options.filters.convYYYYMMDDToDDMMYYYY(res.loanDate),
          }
        });
        vm.paymentRounds = Object.assign([], vm.contract.loan.paymentRounds).map(res => {
          return {
            ...res,
            paymentRoundDate: vm.$options.filters.convYYYYMMDDToDDMMYYYY(res.paymentRoundDate),
          }
        });
      }, 100);
    },
    generatePaymentRounds() {
      const vm = this
      let obj = []
      if (vm.form.loan.loanType && parseInt(vm.form.loan.period) >= 1 && vm.form.loan.paymentDue) {
        const period = parseInt(vm.form.loan.period)
        const paymentDue = vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.form.loan.paymentDue)
        let iDate = new Date(new Date(paymentDue).getFullYear(), new Date(paymentDue).getMonth(), 1)
        for (let i = 0; i < period; i++) {
          obj.push({
            paymentRoundSeq: i + 1,
            paymentRoundDate: moment(getLastDay(iDate)).format('DD-MM-YYYY'),
            paymentRoundType: 'None',
            paymentRoundAmount: 0,
            paymentRoundAmountRestructuring: 0,
          })
          iDate.setMonth(iDate.getMonth() + 1);
        }
      }
      vm.paymentRounds = Object.assign([], obj);
    },
    generatePaymentDescription() {
      const vm = this
      if (vm.form.loan.loanType) {
        const loanType = vm.form.loan.loanType
        vm.form.loan.paymentDescription = vm.loanTypesOptions.filter(res => res.value === loanType)[0].description
      } else {
        vm.form.loan.paymentDescription = ""
      }
    },
    copyPaymentRounds(index) {
      const vm = this
      let obj = []
      let paymentRoundType, paymentRoundAmount, paymentRoundAmountRestructuring
      obj = vm.paymentRounds.map((res, i) => {
        if (i === index) {
          paymentRoundType = res.paymentRoundType
          paymentRoundAmount = parseFloat(res.paymentRoundAmount)
          paymentRoundAmountRestructuring = parseFloat(res.paymentRoundAmountRestructuring)
          return {...res}
        } else if (i > index) {
          return {
            ...res,
            paymentRoundType,
            paymentRoundAmount,
            paymentRoundAmountRestructuring
          }
        } else {
          return {...res}
        }
      })
      vm.paymentRounds = Object.assign([], obj);
    },
    addLoanDetails() {
      const vm = this
      vm.loanDetails.push({
        seq: parseInt(vm.loanDetails.length + 1),
        loanDetailType: 'TuitionFee',
        loanDate: moment().format('DD-MM-YYYY'),
        amount: 0
      })
    },
    delLoanDetails(index) {
      const vm = this
      vm.loanDetails.splice(index, 1)
    },
    addLoanDetailPlans() {
      const vm = this
      vm.loanDetailPlans.push({
        seq: parseInt(vm.loanDetailPlans.length + 1),
        loanDetailType: ILoanDetailType.tuitionFee,
        loanDate: moment().format('DD-MM-YYYY'),
        amount: 0
      })
    },
    delLoanDetailPlans(index) {
      const vm = this
      vm.loanDetailPlans.splice(index, 1)
    },
    async changeStatus(contractStatus) {
      const vm = this
      const confirm_code = Math.floor(1000 + Math.random() * 9000);
      const input_code = prompt("กรุณากรอกรหัสยืนยัน " + confirm_code + " เพื่อยืนยันการบันทึกข้อมูล", "");
      const {updateContractStatus} = vm;
      if (confirm_code === Number(input_code)) {
        if (contractStatus === IContractStatus.approved) {
          await updateContractStatus({
            id: vm.$route.params.id,
            form: {
              contractStatus: contractStatus,
              remark: "",
            },
            vm
          });
        } else {
          alert("not available")
        }
      } else {
        return false;
      }
    },
    async fncGetRestructuringDetailByDate() {
      const vm = this
      const {getRestructuringDetailByDate} = vm;
      let result = await getRestructuringDetailByDate({
        form: {
          id: vm.$route.params.id,
          restructuringDate: vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.restructuringDetail.restructuringDate),
        }
      });
      if (result === null) {
        alert("ไม่พบข้อมูลรายละเอียดธุรกรรมของวันที่ดังกล่าว")
        vm.restructuringDetail.restructuringFeeRemain = 0;
        vm.restructuringDetail.restructuringPenaltyRemain = 0;
        vm.restructuringDetail.restructuringInterestRemain = 0;
        vm.restructuringDetail.principleRemain = 0;
        vm.restructuringDetail.remark = "";
        return false;
      }
      vm.restructuringDetail.restructuringFeeRemain = result.restructuringFeeRemain;
      vm.restructuringDetail.restructuringPenaltyRemain = result.restructuringPenaltyRemain;
      vm.restructuringDetail.restructuringInterestRemain = result.restructuringInterestRemain;
      vm.restructuringDetail.principleRemain = result.principleRemain;
      vm.restructuringDetail.remark = result.remark;
    },
    async addSureties() {
      const vm = this
      vm.activeModal.active = true
    },
    delSureties(index) {
      const vm = this
      vm.suretyDetails.splice(index, 1)
    },
    acceptModal() {
      const vm = this
      const suretyId = vm.surety ? vm.surety.id : null;
      if (vm.suretyDetails.find(res => res.surety.id === suretyId)) {
        alert("คุณได้เลือกผู้ค้ำประกันคนนี้ไปแล้ว")
        return
      }
      if (suretyId === "") {
        alert("กรุณาเลือกผู้ค้ำประกัน")
        return
      }
      vm.suretyDetails.push({
        surety: {id: suretyId},
        relationship: ""
      })
      vm.surety = ""
    },
    cancelModal() {
      const vm = this
      vm.surety = ""
    },
    closeModal() {
      const vm = this
      vm.surety = ""
    },
    suretyName(id) {
      const vm = this
      const surety = vm.sureties.find(res => res.id === id)
      return surety ? surety.fullName : ""
    },
    approvedTxt() {
      if (this.contract.contractStatus === IContractStatus.draft) {
        return "ยืนยันข้อมูล"
      } else {
        return "ปรับสถานะเป็น ปกติ"
      }
    },
    paymentRoundAmount(res) {
      let paymentRoundAmount = 0
      if (res.paymentRoundType === IPaymentRoundType.principle || res.paymentRoundType === IPaymentRoundType.interestFixed) {
        paymentRoundAmount = res.paymentRoundAmount
      }
      return paymentRoundAmount
    },
    paymentRoundAmountRestructuring(res) {
      let paymentRoundAmountRestructuring = 0
      if (res.paymentRoundType === IPaymentRoundType.principle || res.paymentRoundType === IPaymentRoundType.interestFixed) {
        paymentRoundAmountRestructuring = res.paymentRoundAmountRestructuring
      }
      return paymentRoundAmountRestructuring
    },
    async onPressedRefreshSuretyOptions() {
      const {getSuretyContractOptions, $vs} = this;
      $vs.loading();
      await getSuretyContractOptions();
      $vs.loading.close();
    }
  },
  watch: {
    'form.loan.period': {
      immediate: true,
      handler() {
        if (this.created) {
          this.generatePaymentRounds()
        }
      }
    },
    'form.loan.paymentDue': {
      immediate: true,
      handler() {
        if (this.created) {
          this.generatePaymentRounds()
        }
      }
    },
    'form.contractAmount': {
      immediate: true,
      handler(value) {
        if (this.created) {
          if (value >= 1) {
            this.form.contractAmountText = THBText(value);
          } else {
            this.form.contractAmountText = "ศูนย์บาทถ้วน";
          }
        }
      }
    },
    'restructuringDetail.principleRemain': {
      immediate: true,
      handler(value) {
        if (this.created) {
          this.form.contractAmount = value
        }
      }
    },
    reCalculate: {
      immediate: true,
      async handler(value) {
        const vm = this
        if (this.created && !value) {
          vm.reset()
        }
      }
    },
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  }
}
</script>

<style scoped>
.vx-coll-fixed-height {
  display: block;
  width: 100%;
  height: 500px;
  overflow: auto;
}

.vx-coll-fixed-height-extra {
  display: block;
  width: 100%;
  height: 425px;
  overflow: auto;
}
</style>
